import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { navLinks } from "../data";
import { useCart } from "../context/CartContext";

export default function Navbar() {
  const [expanded, setExpanded] = useState(false);
  const { itemCount } = useCart();

  const closeMenu = () => setExpanded(false);

  return (
    <nav className="navbar navbar-expand-lg mu-navbar">
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center gap-2" to="/" onClick={closeMenu}>
          {/* <div className="mu-brand-mark">M</div>
          <div className="mu-brand-text">
            Music<span>Untamed</span>
          </div> */}

          <img src="../../images/logo.png" style={{ width: "80px" }} alt="" srcset="" />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setExpanded((prev) => !prev)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${expanded ? "show" : ""}`}>
          <ul className="navbar-nav mx-auto my-2 my-lg-0">
            {navLinks.map((link) => {
              const isRoute = !link.href.includes("#");
              return (
                <li className="nav-item" key={link.href}>
                  {isRoute ? (
                    <NavLink
                      className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                      to={link.href}
                      end={link.href === "/"}
                      onClick={closeMenu}
                    >
                      {link.label}
                    </NavLink>
                  ) : (
                    <a className="nav-link" href={link.href} onClick={closeMenu}>
                      {link.label}
                    </a>
                  )}
                </li>
              );
            })}
          </ul>
          <div className="d-flex align-items-center gap-3">
            <Link to="/cart" className="navbar-cart-link" onClick={closeMenu}>
              <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                <path d="M3 3h2l2.4 12.4a2 2 0 0 0 2 1.6h8.4a2 2 0 0 0 2-1.6L22 8H6" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="9" cy="21" r="1.4" />
                <circle cx="18" cy="21" r="1.4" />
              </svg>
              {itemCount > 0 && <span className="navbar-cart-badge">{itemCount}</span>}
            </Link>
            <a href="#login" className="fw-semibold" style={{ color: "var(--mu-ink)", fontSize: ".92rem" }}>
              Log In
            </a>
            <a href="#create-account" className="btn-mu-outline">
              Create Account
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
